import { ServiceType } from "./apiServices";

/**
 * Interface for endpoint definition with path and service type
 */
export interface EndpointDefinition {
  path: string;
  service: ServiceType;
}

/**
 * Sender API endpoints
 */
export const SENDER_ENDPOINTS = {
  GET_SHIPMENT_CATEGORIES: {
    path: "/sender/shipment/categories",
    service: ServiceType.SENDER,
  },
  TRAVEL_TRIPS: {
    path: "/sender/travelers-search",
    service: ServiceType.SENDER,
  },
  SEARCH_ITEMS_CHECK: {
    path: "/sender/:userId/items/check",
    service: ServiceType.SENDER,
  },
  DELETE_MY_ITEM: {
    path: "/sender/shipment/:id",
    service: ServiceType.SENDER2,
  },
  UPDATE_MY_ITEM: {
    path: "/sender/shipment/:shipmentId/update",
    service: ServiceType.SENDER2,
  },
  TRACK_ORDER_AS_SENDER: {
    path: "/sender/track-order/:order_id",
    service: ServiceType.SENDER2
  },
  GET_SHIPMENT_DETAILS: {
    path: "/sender/shipment/:id",
    service: ServiceType.SENDER2,
  },
  MY_ORDERS_DETAIL: {
    path: "/sender/:sender_id/my-orders-detail/:order_id",
    service: ServiceType.SENDER,
  },
  CREATE_ITEMS: {
    path: "/sender/shipment/create",
    service: ServiceType.SENDER2,
  },
  SHIPMENT_LISTING: {
    path: "/sender/shipments/items",
    service: ServiceType.SENDER2,
  },
  CATEGORY_LISTING: {
    path: "/sender/shipment/categories",
    service: ServiceType.SENDER2,
  },
  ACCEPT_OFFER: {
    path: "/sender/accept/order",
    service: ServiceType.SENDER2,
  },

  REJECT_OFFER_AS_SENDER: {
    path: "/sender/reject/order",
    service: ServiceType.SENDER2,
  },

  SEND_OFFER_AS_SENDER: {
    path: "/sender/send/offer/request",
    service: ServiceType.SENDER2,
  },
  REJECT_OFFER_REQUEST: {
    path: "/sender/reject/offer/request",
    service: ServiceType.SENDER2,
  },
  ACCEPT_OFFER_REQUEST: {
    path: "/sender/accept/offer/request",
    service: ServiceType.SENDER2,
  },
  SHIPMENT_DETAILS: {
    path: "/sender/shipment/:id",
    service: ServiceType.SENDER2,
  },
  ORDERS_LISTING: {
    path: "/sender/:sender_id/my-orders",
    service: ServiceType.SENDER2,
  },
  ORDER_DETAILS: {
    path: "/sender/order-detail/:order_id",
    service: ServiceType.SENDER2,
  },
  EDIT_CART: {
    path: "/sender/shipment/:order_id/item/:id/update",
    service: ServiceType.SENDER2,
  },
  DROP_OFF: {
    path: "/sender/drop-off",
    service: ServiceType.SENDER2
  },
  RECEIVER_CHECKOUT: {
    path: "/sender/receiver-check-out",
    service: ServiceType.SENDER2
  },
  CREATE_CLAIM: {
    path: "/claims/create",
    service: ServiceType.USER2
  },
  CLAIMS_REASONS: {
    path: "/claims/reasons",
    service: ServiceType.SENDER2
  },
  CLAIMS_DETAILS: {
    path: "/claims/:claim_id",
    service: ServiceType.SENDER2
  },
  PAYMENT_HISTORY: {
    path: "/sender/:sender_id/payment-history",
    service: ServiceType.SENDER2
  },
  PAYMENT_RECEIPT: {
    path: "/sender/payment-history/:ordercode/receipt",
    service: ServiceType.SENDER2
  },
  PIN_ITINERARY: {
    path: "/sender/add-itinerary-to-wishlist",
    service: ServiceType.SENDER2
  },
  UNPIN_ITINERARY: {
    path: "/sender/remove-itinerary-from-wishlist",
    service: ServiceType.SENDER2
  },
  SENDER_PREFERENCES: {
    path: "/sender/:sender_id/sender-preferences",
    service: ServiceType.SENDER2
  },
  UPDATE_SENDER_PREFERENCES: {
    path: "/sender/update-sender-preferences",
    service: ServiceType.SENDER2
  },
  CURRENCY: {
    path: "/sender/currencies",
    service: ServiceType.SENDER2
  },
  RECEIVER_UPDATE: {
    path: "/sender/shipment/order/:order_id/receiver-update",
    service: ServiceType.SENDER2
  },
  PAYMENT_METHODS: {
    path: "/sender/:sender_id/payment-methods",
    service: ServiceType.SENDER2
  },
  SETUP_INTETENT: {
    path: "/sender/:sender_id/payment-methods/setup-intent",
    service: ServiceType.SENDER2
  },
  ATTACH_PAYMENT_METHOD: {
    path: "/sender/payment-methods/attach",
    service: ServiceType.SENDER2
  },
  SET_PAYMENT_METHOD_DEFAULT: {
    path: "/sender/payment-methods/:payment_method_id/default",
    service: ServiceType.SENDER2
  },
  DELETE_METHOD: {
    path: "/sender/payment-methods/:payment_method_id",
    service: ServiceType.SENDER2
  },
  CREATE_NEW_ITEM: {
    path: "/sender/shipment/create-new",
    service: ServiceType.SENDER2
  },
  UPDATE_EXISTING_ITEM: {
    path: "/sender/shipment/:id/update-new",
    service: ServiceType.SENDER2
  },
  CHECK_ITEMS: {
    path: "/sender/:id/items/search",
    service: ServiceType.SENDER2
  },
  CREATE_SETUP_INTENT: {  
    path: "/payment/create-setup-intent",
    service: ServiceType.SENDER2
  },
  VERIFY_AND_SAVE_CARD: {
    path: "/payment/verify-and-save-card",
    service: ServiceType.SENDER2
  },
  GET_PENDING_REQUESTS_BY_SHIPMENT: {
    path: "/sender/:sender_id/shipment/:shipment_id/pending-requests",
    service: ServiceType.SENDER2
  },
  GET_MY_PENDING_REQUESTS_BY_SHIPMENT: {
    path: "/sender/:sender_id/shipment/:shipment_id/my-pending-requests",
    service: ServiceType.SENDER2
  },
  WITHDRAW_OFFER_REQUEST: {
    path: "/sender/withdraw/offer/request",
    service: ServiceType.SENDER2
  }

};

/**
 * Sender API v3 endpoints
 */
export const SENDER_V3_ENDPOINTS = {
  CREATE_SHIPMENT: {
    path: "/sender/shipment/create",
    service: ServiceType.SENDER3,
  },
  UPDATE_SHIPMENT: {
    path: "/sender/shipment/:id/update",
    service: ServiceType.SENDER3,
  },
  SEARCH_ITEMS: {
    path: "/sender/:sender_id/items/search",
    service: ServiceType.SENDER3,
  },
  SEND_OFFER_REQUEST: {
    path: "/sender/send/offer/request",
    service: ServiceType.SENDER3,
  },
  ACCEPT_OFFER_REQUEST: {
    path: "/sender/accept/offer/request",
    service: ServiceType.SENDER3,
  },
  REJECT_OFFER_REQUEST: {
    path: "/sender/reject/offer/request",
    service: ServiceType.SENDER3,
  },
  GET_PENDING_REQUESTS_BY_SHIPMENT: {
    path: "/sender/:sender_id/shipment/:shipment_id/pending-requests",
    service: ServiceType.SENDER3,
  },
  GET_MY_PENDING_REQUESTS_BY_SHIPMENT: {
    path: "/sender/:sender_id/shipment/:shipment_id/my-pending-requests",
    service: ServiceType.SENDER3,
  },
  ORDERS_LISTING: {
    path: "/sender/:sender_id/my-orders",
    service: ServiceType.SENDER3,
  },
  ORDER_DETAILS: {
    path: "/sender/order-detail/:order_id",
    service: ServiceType.SENDER3,
  },
  PAYMENT_HISTORY: {
    path: "/sender/:user_id/payment-history",
    service: ServiceType.SENDER3,
  },
  PAYMENT_RECEIPT: {
    path: "/sender/payment-history/:order_code/receipt",
    service: ServiceType.SENDER3,
  },
  RECEIVER_CHECKOUT: {
    path: "/sender/receiver-check-out",
    service: ServiceType.SENDER3,
  },
  SHIPMENT_LISTING: {
    path: "/sender/shipments/items",
    service: ServiceType.SENDER3,
  },
  SHIPMENT_DETAILS: {
    path: "/sender/shipment/:id",
    service: ServiceType.SENDER3,
  },
  PUBLIC_TRAVEL_SEARCH: {
    path: "/sender/travelers-search-public",
    service: ServiceType.SENDER3,
  },
  TRAVEL_TRIPS: {
    path: "/sender/travelers-search",
    service: ServiceType.SENDER3,
  },
  VERIFY_ORDERCODE: {
    path: "/sender/orderDetail/:order_code",
    service: ServiceType.SENDER3,
  },
  SEND_OTP: {
    path: "/sender/otp/send",
    service: ServiceType.SENDER3,
  },
  VERIFY_OTP: {
    path: "/sender/otp/verify",
    service: ServiceType.SENDER3,
  },
  GET_ORDER_CHAT_INFO: {
    path: "/sender/order/:order_id/chat-info/:sender_id",
    service: ServiceType.SENDER3,
  },
  SKIP_RATING: {
    path: "/sender/order/:order_id/skip-rating/:sender_id",
    service: ServiceType.SENDER3,
  },
  ADD_TRAVELLER_RATING_REVIEW: {
    path: "/sender/add-traveler-rating-review",
    service: ServiceType.SENDER3,
  },
  GET_REVIEWS: {
    path: "/sender/:user_id/reviews",
    service: ServiceType.SENDER3,
  },
};

/**
 * User API endpoints
 */
export const USER_ENDPOINTS = {
  GET_USER_PROFILE: {
    path: "/user/profile/auth/:auth0Id",
    service: ServiceType.USER2,
  },
  GET_USER_PROFILE_BY_ID: {
    path: "/user/profile/:userId",
    service: ServiceType.USER2,
  },
  GET_COUNTRIES: {
    path: "/user/countries",
    service: ServiceType.USER,
  },
  GET_STATES: {
    path: "/user/country/:countryId/states",
    service: ServiceType.USER,
  },
  GET_CITIES: {
    path: "/user/states/:stateId/cities",
    service: ServiceType.USER,
  },
  UPDATE_USER_PROFILE: {
    path: "/user/profile/:userId",
    service: ServiceType.USER2,
  },
  CHANGE_USER_ROLE: {
    path: "/user/switchRole",
    service: ServiceType.USER2,
  },
  CHANGE_USER_AVATAR: {
    path: "/user/profile/avatar/:userId",
    service: ServiceType.USER2,
  },
  GET_AIRPORTS: {
    path: "/user/airports/:search",
    service: ServiceType.USER,
  },
  GET_PRICE_FROM_WEIGHT: {
    path: "/user/get-weight-based-price",
    service: ServiceType.USER2,
  },
  UPLOAD_ID_CARD: {
    path: "/user/upload/id-card",
    service: ServiceType.USER,
  },
  UPLOAD_ITEM_IMAGES: {
    path: "/user/upload/item-images",
    service: ServiceType.USER,
  },
  UPLOAD_IMAGES: {
    path: "/user/upload/images",
    service: ServiceType.USER,
  },
  UPLOAD_IMAGES_V2: {
    path: "/user/upload/images",
    service: ServiceType.USER2,
  },
  DELETE_ACCOUNT: {
    path: '/user/delete-account',
    service: ServiceType.USER
  },
  UPDATE_PASSWORD: {
    path: '/user/auth0/update-password',
    service: ServiceType.USER
  },
  KYC: {
    path: "/user/generate-kyc-qrcode",
    service: ServiceType.USER
  },
  UPLOAD_ITEM_IMAGES_V2: {
    path: "/user/upload/item-images",
    service: ServiceType.USER2
  },
  SETTING: {
    path: "/user/getSetting",
    service: ServiceType.USER2
  },
  UPDATE_THE_PASSWORD: {
    path: '/user/update-password',
    service: ServiceType.USER2
  },
  DELETE_THE_ACCOUNT: {
    path: '/user/delete-account',
    service: ServiceType.USER2
  },
  ISSUE_REASONS: {
    path: '/user/reasons',
    service: ServiceType.USER2
  },
  SUBMIT_ISSUE: {
    path: '/user/submit',
    service: ServiceType.USER2
  },
  UPLOAD_ISSUE_IMAGES: {
    path: '/user/upload-item-images',
    service: ServiceType.USER2
  },
  CONTACT: {
    path: '/user/contact',
    service: ServiceType.USER2
  },
  SEND_OTP: {
    path: '/user/otp/send',
    service: ServiceType.USER2
  },
  VERIFY_OTP: {
    path: '/user/otp/verify',
    service: ServiceType.USER2
  },
  RESEND_OTP: {
    path: '/user/otp/resend',
    service: ServiceType.USER2
  },
  GET_TIME_PREFERENCE: {
    path: '/user/:userId/time-preference',
    service: ServiceType.USER2,
  },
  UPDATE_TIME_PREFERENCE: {
    path: '/user/time-preference',
    service: ServiceType.USER2,
  },
  GET_DISTANCE_PREFERENCE: {
    path: '/user/:userId/distance-preference',
    service: ServiceType.USER2,
  },
  GET_REASONS:{
    path: '/user/support/get-reasons',
    service: ServiceType.USER2
  },
  USER_SUPPORT: {
    path: '/user/support/create-issue',
    service: ServiceType.USER2
  },
  GET_DEFAULT_ROLES:{
  path: '/user/getDefaultRoles',
    service: ServiceType.USER2
  },
  DELETE_PROFILE_IMAGE: {
  path: '/user/:userId/profile/avatar',
    service: ServiceType.USER2
  },
  GET_PLATFORM_FEE_SETTING: {
    path: '/user/platform-fee-setting',
    service: ServiceType.USER2
  },
  GET_OFFER_EXPIRATION_SETTINGS: {
    path: '/user/offer-expiration-settings',
    service: ServiceType.USER2
  }
};

/**
 * User API v3 endpoints
 */
export const USER_V3_ENDPOINTS = {
  GET_CORRIDOR_PRICING: {
    path: "/user/corridors/pricing",
    service: ServiceType.USER3,
  },
  GET_WEIGHT_PRICING: {
    path: "/user/corridors/weight-pricing",
    service: ServiceType.USER3,
  },
  GET_CORRIDOR_COUNTRIES: {
    path: "/user/corridors/countries",
    service: ServiceType.USER3,
  },
  GET_USER_PROFILE: {
    path: "/user/profile/auth/:auth_id",
    service: ServiceType.USER3,
  },
  UPDATE_USER_PROFILE: {
    path: "/user/profile/:user_id",
    service: ServiceType.USER3,
  },
  GET_CURRENCIES: {
    path: "/user/currencies",
    service: ServiceType.USER3,
  },
  UPDATE_USER_CURRENCY: {
    path: "/user/currency/:user_id",
    service: ServiceType.USER3,
  },
  GET_WEIGHT_UNITS: {
    path: "/user/weight-units",
    service: ServiceType.USER3,
  },
  GET_LATEST_ORDERS: {
    path: "/user/:user_id/latest/orders",
    service: ServiceType.USER3,
  },
};

/**
 * traveller API endpoints
 */
export const traveller_ENDPOINTS = {
  SEARCH_TRIPS: {
    path: "/traveler/senders-search",
    service: ServiceType.traveller2,
  },
  CREATE_ITINERARY: {
    path: "/traveler/create-itinerary",
    service: ServiceType.traveller2,
  },
  UPDATE_ITINERARY: {
    path: "/traveler/update-itinerary/:itinerary_id",
    service: ServiceType.traveller2,
  },
  UPLOAD_ITINERARY_IMAGE: {
    path: "/traveler/itineraries/documents",
    service: ServiceType.traveller2,
  },
  PUBLIC_SENDER_SEARCH: {
    path: "/traveler/senders-search-public",
    service: ServiceType.traveller2,
  },
  DELETE_ITINERARY: {
    path: "/traveler/:traveller_id/delete-itinerary/:itinerary_id",
    service: ServiceType.traveller2,
  },
  CANCEL_EDIT_ITEM_REQUEST: {
    path: "/traveler/cancel/edit/item/request",
    service: ServiceType.traveller2,
  },
  APPROVE_EDIT_ITEM_REQUEST: {
    path: "/traveler/approve/edit/item/request",
    service: ServiceType.traveller2,
  },
  OFFER_REJECT: {
    path: "/traveler/reject/offer/request",
    service: ServiceType.traveller2,
  },
  ACCEPT_OFFER: {
    path: "/traveler/accept/offer/request",
    service: ServiceType.traveller2,
  },
  SEND_OFFER: {
    path: "/traveler/send/offer/request",
    service: ServiceType.traveller2,
  },
  GET_ITINERARY_DETAILS: {
    path: "/traveler/itinerary/:itinerary_id",
    service: ServiceType.traveller2,
  },
  ITINERARY_DETAILS: {
    path: "/traveler/itinerary/:itinerary_id",
    service: ServiceType.traveller2,
  },
  UPDATE_ITINERARY_WEIGHT: {
    path: "/traveler/update-itinerary-weight/:itinerary_id",
    service: ServiceType.traveller2,
  },
  ITINERARY_ORDERS: {
    path: "/traveler/itinerary/:itinerary_id/orders",
    service: ServiceType.traveller2,
  },
  ORDERS_DETAILS: {
    path: "/traveler/order-details",
    service: ServiceType.traveller2,
  },
  PICK_UP: {
    path: "/traveler/pickup-off",
    service: ServiceType.traveller2,
  },
  DELIVERY: {
    path: "/traveler/delivery-checkout",
    service: ServiceType.traveller2,
  },
  WALLET_MONTHLY_BALANCE: {
    path: "/traveler/:userId/wallet-monthly-balance",
    service: ServiceType.traveller2
  },
  ORDER_HISTORY: {
    path: "/traveler/:userId/orders-history",
    service: ServiceType.traveller2
  },
  CURRENCY: {
    path: "/traveler/currencies",
    service: ServiceType.traveller2
  },
  TRAVEL_PREFERENCES: {
    path: "/traveler/:userId/travel-preferences",
    service: ServiceType.traveller2
  },
  UPDATE_TRAVEL_PREFERENCES: {
    path: "/traveler/update-travel-preferences",
    service: ServiceType.traveller2
  },
  PIN_SHIPMENT: {
    path: "/traveler/add-shipment-to-wishlist",
    service: ServiceType.traveller2
  },
  UNPIN_SHIPMENT: {
    path: "/traveler/remove-shipment-from-wishlist",
    service: ServiceType.traveller2
  },
  CREATE_ITINERARY_CATEGORY: {
    path: "/traveler/create-itinerary-category",
    service: ServiceType.traveller2
  },
  UPDATE_ITINERARY_CATEGORY: {
    path: "/traveler/update-itinerary-category/:itinerary_id",
    service: ServiceType.traveller2
  },
  CHECK_ITINERARIES: {
    path: "/traveler/:id/itineraries/search",
    service: ServiceType.traveller2
  },
  GET_PENDING_REQUESTS_BY_ITINERARY: {
    path: "/traveler/itinerary/:itinerary_id/pending-requests",
    service: ServiceType.traveller2
  },
  GET_MY_PENDING_REQUESTS_BY_ITINERARY: {
    path: "/traveler/itinerary/:itinerary_id/my-pending-requests",
    service: ServiceType.traveller2
  },
  WITHDRAW_OFFER_REQUEST: {
    path: "/traveler/withdraw/offer/request",
    service: ServiceType.traveller2
  }

};

/**
 * traveller API v3 endpoints
 */
export const TRAVELLER_V3_ENDPOINTS = {
  CREATE_ITINERARY: {
    path: "/traveler/create-itinerary",
    service: ServiceType.traveller3,
  },
  UPDATE_ITINERARY: {
    path: "/traveler/update-itinerary/:itinerary_id",
    service: ServiceType.traveller3,
  },
  LIST_ITINERARY: {
    path: "/traveler/my-travels/:userId",
    service: ServiceType.traveller3,
  },
  WALLET_BALANCE_TRANSACTIONS: {
    path: "/traveler/:userId/balance-transactions",
    service: ServiceType.traveller3,
  },
  CHECK_ITINERARIES: {
    path: "/traveler/:traveler_id/itineraries/search",
    service: ServiceType.traveller3,
  },
  SEND_OFFER_REQUEST: {
    path: "/traveler/send/offer/request",
    service: ServiceType.traveller3,
  },
  ACCEPT_OFFER_REQUEST: {
    path: "/traveler/accept/offer/request",
    service: ServiceType.traveller3,
  },
  REJECT_OFFER_REQUEST: {
    path: "/traveler/reject/offer/request",
    service: ServiceType.traveller3,
  },
  GET_PENDING_REQUESTS_BY_ITINERARY: {
    path: "/traveler/itinerary/:itinerary_id/pending-requests",
    service: ServiceType.traveller3,
  },
  GET_MY_PENDING_REQUESTS_BY_ITINERARY: {
    path: "/traveler/itinerary/:itinerary_id/my-pending-requests",
    service: ServiceType.traveller3,
  },
  ITINERARY_DETAILS: {
    path: "/traveler/itinerary/:itinerary_id",
    service: ServiceType.traveller3,
  },
  ITINERARY_ORDERS: {
    path: "/traveler/itinerary/:itinerary_id/orders",
    service: ServiceType.traveller3,
  },
  ORDER_DETAILS: {
    path: "/traveler/order-details",
    service: ServiceType.traveller3,
  },
  ORDER_HISTORY: {
    path: "/traveler/:traveler_id/orders-history",
    service: ServiceType.traveller3,
  },
  SEARCH_TRIPS: {
    path: "/traveler/senders-search",
    service: ServiceType.traveller3,
  },
  PUBLIC_SENDER_SEARCH: {
    path: "/traveler/senders-search-public",
    service: ServiceType.traveller3,
  },
  GET_ORDER_CHAT_INFO: {
    path: "/traveler/order/:order_id/chat-info/:traveler_id",
    service: ServiceType.traveller3,
  },
  SKIP_RATING: {
    path: "/traveler/order/:order_id/skip-rating/:traveler_id",
    service: ServiceType.traveller3,
  },
  ADD_SENDER_RATING_REVIEW: {
    path: "/traveler/add-sender-rating-review",
    service: ServiceType.traveller3,
  },
  GET_REVIEWS: {
    path: "/traveler/:user_id/reviews",
    service: ServiceType.traveller3,
  },
};

export const NOTIFICATION_ENDPOINTS = {
  SIGNALR_NEGOTIATE: {
    path: "/notification/signalr/negotiate",
    service: ServiceType.NOTIFICATION,
  },
  SEND_MESSAGE: {
    path: "/notification/send-message",
    service: ServiceType.NOTIFICATION,
  },
  BROADCAST_MESSAGE: {
    path: "/notification/broadcast-message",
    service: ServiceType.NOTIFICATION,
  },
  SIGNALR_STATUS: {
    path: "/notification/signalr/status",
    service: ServiceType.NOTIFICATION,
  },
  CREATE_CHAT_ROOM: {
    path: "/notification/chat/room/create",
    service: ServiceType.NOTIFICATION2,
  },
  JOIN_CHAT_ROOM: {
    path: "/notification/chat/room/join",
    service: ServiceType.NOTIFICATION,
  },
  GET_USER_CHAT_ROOMS: {
    path: "/notification/chat/user/:userId/rooms",
    service: ServiceType.NOTIFICATION,
  },
  GET_CHAT_ROOM_DETAILS: {
    path: "/notification/chat/room/:roomId/details",
    service: ServiceType.NOTIFICATION,
  },
  SEND_CHAT_MESSAGE: {
    path: "/notification/chat/message/send",
    service: ServiceType.NOTIFICATION2,
  },
  GET_CHAT_MESSAGES: {
    path: "/notification/chat/room/:roomId/messages",
    service: ServiceType.NOTIFICATION2,
  },
  MARK_MESSAGES_READ: {
    path: "/notification/chat/messages/mark-read",
    service: ServiceType.NOTIFICATION,
  },
  GET_MISSED_NOTIFICATIONS: {
    path: "/notification/user/:userId",
    service: ServiceType.NOTIFICATION,
  },
  MARK_NOTIFICATION_READ: {
    path: "/notification/:notificationId/mark-read",
    service: ServiceType.NOTIFICATION,
  }

};

/**
 * Notification API v3 endpoints (order group chat)
 */
export const NOTIFICATION_V3_ENDPOINTS = {
  SEND_GROUP_CHAT_MESSAGE: {
    path: "/notification/order-group-chat/message/send",
    service: ServiceType.NOTIFICATION3,
  },
  GET_GROUP_CHAT_MESSAGES: {
    path: "/notification/order-group-chat/:chat_room_id/messages",
    service: ServiceType.NOTIFICATION3,
  },
  GET_GROUP_CHAT_ROOM_DETAILS: {
    path: "/notification/order-group-chat/:chat_room_id/details",
    service: ServiceType.NOTIFICATION3,
  },
  CREATE_RECEIVER_GROUP_CHAT_ROOM: {
    path: "/notification/order-group-chat/receiver/create",
    service: ServiceType.NOTIFICATION3,
  },
  NEGOTIATE_RECEIVER_GROUP_CHAT: {
    path: "/notification/order-group-chat/receiver/negotiate",
    service: ServiceType.NOTIFICATION3,
  },
  GET_RECEIVER_GROUP_CHAT_ROOM_DETAILS: {
    path: "/notification/order-group-chat/receiver/:chat_room_id/details",
    service: ServiceType.NOTIFICATION3,
  },
  GET_RECEIVER_GROUP_CHAT_MESSAGES: {
    path: "/notification/order-group-chat/receiver/:chat_room_id/messages",
    service: ServiceType.NOTIFICATION3,
  },
  SEND_RECEIVER_GROUP_CHAT_MESSAGE: {
    path: "/notification/order-group-chat/receiver/message/send",
    service: ServiceType.NOTIFICATION3,
  },
};

/**
 * Payout API endpoints
 */
export const PAYOUT_ENDPOINTS = {
  PAYONEER_SETUP: {
    path: "/api/v1/payouts/payoneer/setup",
    service: ServiceType.PAYOUT,
  },
  PAYONEER_STATUS: {
    path: "/api/v1/payouts/payoneer/status",
    service: ServiceType.PAYOUT,
  },
  CREATE_PAYOUT_REQUEST: {
    path: "/api/v1/payouts/payout-request",
    service: ServiceType.PAYOUT,
  },
  GET_PAYOUT_REQUESTS: {
    path: "/api/v1/payouts/payout-request",
    service: ServiceType.PAYOUT,
  },
  GET_PAYOUT_REQUEST_BY_ID: {
    path: "/api/v1/payouts/payout-request/:id",
    service: ServiceType.PAYOUT,
  },
};

/**
 * Settings API endpoints
 */
export const SETTINGS_ENDPOINTS = {
  GET_DISTANCE_PREFS: {
    path: "/user/settings/distance",
    service: ServiceType.USER,
  },
  UPDATE_DISTANCE_PREFS: {
    path: "/user/settings/distance",
    service: ServiceType.USER,
  },
  GET_DROP_PICK_TIME: {
    path: "/user/settings/drop-pick-time",
    service: ServiceType.USER,
  },
  UPDATE_DROP_PICK_TIME: {
    path: "/user/settings/drop-pick-time",
    service: ServiceType.USER,
  },
};

/**
 * Utility function to help construct full endpoint URLs or get endpoint info
 */
export const getEndpointInfo = (endpoint: EndpointDefinition): EndpointDefinition => {
  return endpoint;
};